/* VENZE · Energía sin bajones: gráfica café vs Energy + Focus y animaciones de la sección */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  // Misma curva de aceleración que el resto de la ficha: cubic-bezier(0.22, 1, 0.36, 1)
  function bezier(x1, y1, x2, y2) {
    function A(a, b) { return 1 - 3 * b + 3 * a; }
    function B(a, b) { return 3 * b - 6 * a; }
    function C(a) { return 3 * a; }
    function calc(t, a, b) { return ((A(a, b) * t + B(a, b)) * t + C(a)) * t; }
    function slope(t, a, b) { return 3 * A(a, b) * t * t + 2 * B(a, b) * t + C(a); }
    return function (x) {
      var t = x;
      for (var i = 0; i < 8; i++) { var s = slope(t, x1, x2); if (!s) break; t -= (calc(t, x1, x2) - x) / s; }
      return calc(Math.max(0, Math.min(1, t)), y1, y2);
    };
  }
  var ease = bezier(0.22, 1, 0.36, 1);

  // Curvas ilustrativas (horas desde la toma)
  function venze(t) { return 0.72 * (1 - Math.exp(-Math.pow(t / 2.2, 1.8))) / (1 + Math.exp((t - 7.4) / 1.0)); }
  function coffee(t) {
    if (t <= 0) return 0;
    var k = 1.4, tp = 0.75;
    return Math.pow(t / tp, k) * Math.exp(k * (1 - t / tp)) - 0.12 * Math.exp(-Math.pow((t - 4.1) / 1.0, 2));
  }

  function Chart(svg, animate) {
    var SPAN = 9, yMax = 1.12, yMin = -0.2, uid = svg.getAttribute('data-uid') || Math.random().toString(36).slice(2);
    var L = {
      y: svg.getAttribute('data-l-y') || '', start: svg.getAttribute('data-l-start') || '', hour: svg.getAttribute('data-l-hour') || '',
      coffee: svg.getAttribute('data-l-coffee') || '', dip: svg.getAttribute('data-l-dip') || '', venze: svg.getAttribute('data-l-venze') || ''
    };
    var W, H, P, narrow, clip, cols = [], pins = [], raf, timer, playing = false;

    function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); (p || svg).appendChild(e); return e; }
    function X(t) { return P.l + t / SPAN * (W - P.l - P.r); }
    function Y(v) { return P.t + (yMax - v) / (yMax - yMin) * (H - P.t - P.b); }
    function line(f) {
      var d = '';
      for (var i = 0; i <= 200; i++) { var t = SPAN * i / 200; d += (i ? 'L' : 'M') + X(t).toFixed(1) + ' ' + Y(f(t)).toFixed(1); }
      return d;
    }
    function chip(parent, cx, y, txt, solid, up) {
      if (!txt) return;
      var g = el('g', { 'class': 'cfx-chip ' + (solid ? 'cfx-chip--v' : 'cfx-chip--c'), style: '--dy:' + (up ? 8 : -8) + 'px' }, parent);
      var fs = narrow ? 9.5 : 10, h = narrow ? 19 : 21;
      var r = el('rect', { y: y, height: h, rx: 2, 'stroke-width': 1 }, g);
      var t = el('text', { y: y + h / 2 + fs * 0.36, 'font-size': fs, 'font-weight': 700, 'letter-spacing': '0.14em', 'text-anchor': 'middle' }, g);
      t.textContent = txt;
      var w = t.getBBox().width + 18, x = Math.max(1, Math.min(cx - w / 2, W - w - 1));
      r.setAttribute('x', x); r.setAttribute('width', w); t.setAttribute('x', x + w / 2 + 1);
    }

    function draw() {
      var cs = getComputedStyle(svg.parentNode);
      W = svg.parentNode.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
      if (W <= 0) return false;
      narrow = W < 500;
      H = narrow ? Math.round(W * 0.8) : Math.round(W * 0.47);
      P = { l: 18, r: 2, t: 46, b: 40 };
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('width', W); svg.setAttribute('height', H);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      cols = []; pins = [];

      var defs = el('defs', {});
      var cp = el('clipPath', { id: 'cfx-rv-' + uid }, defs);
      clip = el('rect', { x: -4, y: -4, width: W + 8, height: H + 8 }, cp);
      var va = el('clipPath', { id: 'cfx-va-' + uid }, defs);
      el('path', { d: line(venze) + 'L' + X(SPAN) + ' ' + Y(0) + 'L' + X(0) + ' ' + Y(0) + 'Z' }, va);

      // Ejes
      el('line', { 'class': 'cfx-axis', x1: X(0), x2: X(0), y1: P.t - 14, y2: Y(0) });
      if (L.y) {
        var yl = el('text', { 'class': 'cfx-t-axis', transform: 'translate(' + (X(0) - 8) + ',' + (P.t - 14) + ') rotate(-90)', 'text-anchor': 'end', 'font-size': 9.5, 'font-weight': 700, 'letter-spacing': '0.16em' });
        yl.textContent = L.y;
      }
      [0, 2, 4, 6, 8].forEach(function (h) {
        el('line', { 'class': 'cfx-axis', x1: X(h), x2: X(h), y1: Y(0), y2: Y(0) + 5 });
        var t = el('text', { 'class': 'cfx-t-axis', x: X(h), y: H - 6, 'text-anchor': h === 0 ? 'start' : 'middle', 'font-size': 10, 'font-weight': 700, 'letter-spacing': '0.12em' });
        t.textContent = h === 0 ? L.start : h + ' ' + L.hour;
      });

      var g = el('g', { 'clip-path': 'url(#cfx-rv-' + uid + ')' });
      // Puntos como los de la etiqueta: pequeños al principio y más grandes con las horas
      var dg = el('g', { 'class': 'cfx-dots', 'clip-path': 'url(#cfx-va-' + uid + ')' }, g);
      var sp = narrow ? 8 : 11, top = Y(0.75);
      for (var x = X(0) + sp / 2; x < X(SPAN); x += sp) {
        var k = (x - X(0)) / (X(SPAN) - X(0)), r = 0.45 + (narrow ? 1.85 : 2.55) * Math.pow(k, 0.85);
        var cg = el('g', { 'class': 'cfx-col' }, dg), row = 0, limit = Y(venze(SPAN * k)) - r;
        for (var y = Y(0) - sp / 2; y > top && y >= limit; y -= sp, row++) {
          el('circle', { cx: x.toFixed(1), cy: y.toFixed(1), r: r.toFixed(2), style: 'transition-delay:' + Math.min(row * 16, 260) + 'ms' }, cg);
        }
        cols.push({ el: cg, x: x });
      }
      el('path', { 'class': 'cfx-coffee', d: line(coffee), 'stroke-width': 1.75, 'stroke-dasharray': '5 5', 'stroke-linecap': 'round' }, g);
      el('path', { 'class': 'cfx-venze', d: line(venze), 'stroke-width': 2.25, 'stroke-linejoin': 'round' }, g);
      el('line', { 'class': 'cfx-base', x1: X(0), x2: X(SPAN), y1: Y(0), y2: Y(0), 'stroke-width': 1 });

      // Marcas: cuadrado como los del timeline + etiqueta
      var h = narrow ? 19 : 21;
      [[0.75, coffee, L.coffee, false, true], [4.1, coffee, L.dip, false, false], [4.7, venze, L.venze, true, true]].forEach(function (m) {
        var px = X(m[0]), py = Y(m[1](m[0])), pg = el('g', { 'class': 'cfx-pin' });
        el('rect', { 'class': 'cfx-sq ' + (m[3] ? 'cfx-sq--v' : 'cfx-sq--c'), x: px - 4.5, y: py - 4.5, width: 9, height: 9, rx: 2, 'stroke-width': 1.5 }, pg);
        chip(pg, px, m[4] ? py - 12 - h : py + 12, m[2], m[3], m[4]);
        pins.push({ el: pg, x: px });
      });
      return true;
    }

    function mark(x) {
      for (var i = 0; i < cols.length; i++) if (cols[i].x <= x) cols[i].el.classList.add('on');
      for (var j = 0; j < pins.length; j++) if (pins[j].x <= x) pins[j].el.classList.add('on');
    }
    function hideAll() {
      svg.classList.add('cfx-reset');
      cols.concat(pins).forEach(function (c) { c.el.classList.remove('on'); });
      if (clip) clip.setAttribute('width', 0);
      svg.getBoundingClientRect();
      svg.classList.remove('cfx-reset');
    }
    function showAll() {
      svg.classList.add('cfx-reset');
      if (clip) clip.setAttribute('width', W + 8);
      mark(Infinity);
      svg.getBoundingClientRect();
      svg.classList.remove('cfx-reset');
    }
    function stop() { cancelAnimationFrame(raf); clearTimeout(timer); playing = false; }
    function play() {
      if (!animate) return;
      stop(); hideAll(); playing = true;
      var dur = 2400, t0 = null, x0 = X(0), x1 = X(SPAN);
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var k = Math.min(1, (ts - t0) / dur), x = x0 + (x1 - x0) * ease(k);
        clip.setAttribute('width', x + 4); mark(x);
        if (k < 1) raf = requestAnimationFrame(frame); else playing = false;
      }
      raf = requestAnimationFrame(frame);
      timer = setTimeout(function () { if (playing) { stop(); showAll(); } }, dur + 600);
    }
    function build() { stop(); if (draw()) { if (animate) svg.classList.add('cfx-play'); showAll(); } }

    build();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
    var rt, lastW = svg.parentNode.clientWidth;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (svg.parentNode.clientWidth !== lastW) { lastW = svg.parentNode.clientWidth; build(); } }, 150);
    });

    if (animate) {
      // Como el resto de la ficha: se anima al entrar y se rearma al salir
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.45) play();
          else if (!e.isIntersecting) { stop(); hideAll(); }
        });
      }, { threshold: [0, 0.45] });
      io.observe(svg);
    }
  }

  function countUp(n) {
    var to = parseFloat(n.getAttribute('data-count')) || 0, suffix = n.getAttribute('data-suffix') || '', t0 = null, dur = 1100;
    function f(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      n.textContent = Math.round(to * ease(k)) + suffix;
      if (k < 1) requestAnimationFrame(f);
    }
    requestAnimationFrame(f);
    setTimeout(function () { n.textContent = to + suffix; }, dur + 500);
  }

  function init(root) {
    if (!root || root.getAttribute('data-cfx-init') === '1') return;
    root.setAttribute('data-cfx-init', '1');
    var animate = root.getAttribute('data-cfx-animate') !== 'false' && hasIO && !reduce;
    var svg = root.querySelector('[data-cfx-svg]');
    if (svg) Chart(svg, animate);
    if (!animate) return;
    root.classList.add('cfx-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        e.target.classList.toggle('is-inview', e.isIntersecting);
        var n = e.target.querySelector('[data-count]');
        if (n && e.isIntersecting) countUp(n);
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('[data-cfx-reveal]').forEach(function (n) { io.observe(n); });
  }

  function initAll() { document.querySelectorAll('[data-cfx]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target && e.target.querySelector('[data-cfx]');
    if (s) init(s);
  });
})();